import { SparklesIcon } from '@heroicons/react/24/outline';
import { Button } from '../ui/Button';
import { ReactNode } from 'react';
import { EmpreenderApps } from '../lib/AppsArray';
import { useSubMenu } from '../SubMenuContext';
import { useTranslation } from '../lib/i18n/TranslationContext';
import EventHeader from '../ui/EventHeader/EventHeader';
interface PerfilDashProps {
	name: string;
	children?: ReactNode;
	appName?: string;
	appDescription: string;
	imgSrc?: string;
	color: string;
	icon?: ReactNode;
	suportLink?: string;
}

const PerfilDash = ({ name, children, appName, appDescription, imgSrc, color, icon, suportLink }: PerfilDashProps) => {
	const { t } = useTranslation();
	const { app } = useSubMenu();

	const matchApp = EmpreenderApps.find((a) => a.tags.some((tag) => tag?.toLowerCase() === app?.toLowerCase()));

	return (
		<>
			<div className='w-80 flex flex-col gap-4 text-center items-center'>
				<div className='overflow-hidden rounded-full border-2 border-white size-16 p-2 text-white flex items-center justify-center text-xl' style={{ backgroundColor: color }}>
					{icon ? icon : <img className='size-full' src={imgSrc} />}
				</div>

				<div className='flex flex-col gap-2 max-[460px]:w-[95%]'>
					<h1 className='text-gray-900 font-inter text-3xl font-semibold leading-9 tracking-tight'>{appName ?? matchApp?.name}</h1>
					<span className='text-gray-600 text-center font-inter text-sm font-normal leading-5'>
						{t('Bem-vindo')}, <strong>{name?.split(' ')[0]}</strong>. {appDescription}.
					</span>
				</div>

				<div className='flex flex-row gap-2'>
					<Button asChild className='bg-white/50' variant={'secondary'}>
						<a href={matchApp?.suportLink || suportLink || 'https://suporte.com.br'} className='flex flex-row gap-1.5 leading-4' target='_blank'>
							<SparklesIcon className='size-3.5 text-gray-900' />
							{t('Suporte')}
						</a>
					</Button>

					{children ? children : ''}
				</div>
			</div>

			<EventHeader />
		</>
	);
};

export default PerfilDash;
